<div
  *ngIf="!isLoading && session && !alreadyConfirm"
  class="w-full lg:max-w-full lg:flex login-page"
  class="w-full lg:max-w-full lg:flex login-page"
>
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      background-image: url('assets/img/jpo2025.png');
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    "
  >
    <div class="w-4/5 grid-cols-1 flex place-content-center">
      <app-card-form style="opacity: 0.7">
        <div id="page-one">
          <div class="flex justify-between mb-10">
            <div
              class="logo-icon"
              style="background-image: url('assets/img/logo_unchk.png')"
            ></div>
            <div
              class="logo-icon"
              style="background-image: url('assets/img/logo_master_card.png')"
            ></div>
          </div>
          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="font-bold text-2xl">
                FORMULAIRE DE VALIDATION DE PARTICIPATION À L'ACTIVITE :
                {{ responseInfo.activityName }}
              </span>
              <br />
              Programme Force-N
            </div>
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="confirmationForm" class="space-y-6">
            <div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl">
                  I. INFORMATIONS PERSONNELLES</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 md:gap-6 my-6">
                <!-- Label global : visible uniquement en DESKTOP -->
                <div class="col-span-3 md:col-span-1 hidden md:block">
                  <div class="flex items-center gap-1">
                    <span>Prénom - Nom</span>
                    <span class="text-red-500">*</span>
                  </div>
                </div>

                <!-- Prénom : label visible uniquement en MOBILE -->
                <div class="col-span-3 md:col-span-1">
                  <label for="prenom" class="block mb-5 font-medium md:hidden">
                    Prénom <span class="text-red-500">*</span>
                  </label>

                  <input
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-gray-300"
                    formControlName="prenom"
                  />

                  <!-- Sous-label desktop (comme ton ancien style) -->
                  <p class="mt-3 hidden md:block">Prénom</p>
                </div>

                <!-- Nom : label visible uniquement en MOBILE -->
                <div class="col-span-3 md:col-span-1">
                  <label
                    for="nom"
                    class="block mb-5 mt-8 font-medium md:hidden"
                  >
                    Nom <span class="text-red-500">*</span>
                  </label>

                  <input
                    type="text"
                    id="nom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-gray-300 bg-white"
                    formControlName="nom"
                  />

                  <!-- Sous-label desktop -->
                  <p class="mt-3 hidden md:block">Nom</p>
                </div>
              </div>
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Adresse email &nbsp;
                      <p style="color: #ff0000">*</p>
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="email"
                      id="email"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      formControlName="email"
                      placeholder="Par ex : monnom@exemple.com"
                    />
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Code validation &nbsp;
                      <p style="color: #ff0000">*</p>
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="flex space-x-10">
                    <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      formControlName="pin1"
                      class="w-12 h-12 text-center text-lg rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300"
                      (keypress)="onlyNumber($event)"
                      (input)="autoFocus($event, 'pin2')"
                      [style.border]="
                        isFieldInvalid('pin1') ? '2px solid #eb1c1c' : ''
                      "
                    />

                    <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      formControlName="pin2"
                      class="w-12 h-12 text-center text-lg rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300"
                      (keypress)="onlyNumber($event)"
                      (input)="autoFocus($event, 'pin3')"
                      [style.border]="
                        isFieldInvalid('pin2') ? '2px solid #eb1c1c' : ''
                      "
                    />

                    <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      formControlName="pin3"
                      class="w-12 h-12 text-center text-lg rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300"
                      (keypress)="onlyNumber($event)"
                      (input)="autoFocus($event, 'pin4')"
                      [style.border]="
                        isFieldInvalid('pin3') ? '2px solid #eb1c1c' : ''
                      "
                    />

                    <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      formControlName="pin4"
                      class="w-12 h-12 text-center text-lg rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300"
                      (keypress)="onlyNumber($event)"
                      [style.border]="
                        isFieldInvalid('pin4') ? '2px solid #eb1c1c' : ''
                      "
                    />
                  </div>
                </div>
              </div>

              <hr class="h-1 my-8 bg-green-500 border-0 dark:bg-gray-700" />

              <div
                class="flex justify-center items-center"
                *ngIf="filled"
                style="color: #eb1c1c"
              >
                Veuillez renseigner tous les champs requis!
              </div>
              <div
                class="flex justify-center items-center"
                *ngIf="!codeMatched"
                style="color: #eb1c1c"
              >
                Le code de validation ne correspond pas!
              </div>

              <div>
                <app-spinner *ngIf="showSpinner"></app-spinner>
              </div>

              <div class="flex justify-end items-center">
                <button
                  type="submit"
                  class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                  [disabled]="confirmationForm.invalid || isSubmitting"
                  (click)="onSubmitForm()"
                >
                  Confirmer
                </button>
              </div>

              <div class="flex justify-center mt-8">
                <div
                  class="logo-icon"
                  style="background-image: url('assets/img/logo_force_n.png')"
                ></div>
              </div>
            </div>
          </form>
        </div>
      </app-card-form>
    </div>
  </div>
</div>

<!-- Les notifications! -->

<!-- *ngIf="alreadyConfirm" -->
<div
  *ngIf="alreadyConfirm"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/jpo2025_mobile.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-blue-500 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 8.5h.01M11 11h1v4m9-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>

            <h3
              class="mb-5 text-lg font-normal text-gray-800 dark:text-gray-400"
            >
              <strong
                >{{ responseInfo?.firstName }}
                {{ " " + responseInfo?.lastName }}</strong
              >, est déjà présent(e) à l'activité
              <strong>{{ responseInfo?.activityName }}</strong
              >.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- *ngIf="submitSuccess" -->
<div
  *ngIf="succes"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/jpo2025_mobile.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-green-500 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12.75l2.25 2.25L15 10.5m5.25 1.5a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z"
              />
            </svg>

            <h3
              class="mb-5 text-lg font-normal text-gray-800 dark:text-gray-400"
            >
              La présence à l’activité
              <strong>{{ responseInfo.activityName }}</strong> est bien
              enregistrée!
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- *ngIf="!isLoading && noSession" -->

<div
  *ngIf="error"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/jpo2025_mobile.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-red-500 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-800 dark:text-gray-400"
            >
              Nous rencontrons des soucis actuellemnet, merci de réessayer
              plutard.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
